module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia4-bfedd9e10aa00fa5c70f1badb6ce519f.jpg";